import { environment } from 'src/environments/environment';

export const ApiEndpoints = {
  Identity: {
    Authenticate: environment.mainapiUrl + '/identity/authenticate',
    DispatcherLogin: environment.mainapiUrl + '/identity/dispatcher-login',
    CustomerLogin: environment.mainapiUrl + '/identity/customer-login',
    CustomersLoginUsingSSo:
      environment.mainapiUrl + '/identity/customers-login-using-sso',
    DriverLogin: environment.mainapiUrl + '/identity/driver-login',
    CheckIfEmailExist:
      environment.mainapiUrl + '/identity/check-existing-email/',
    Logout: environment.mainapiUrl + '/identity/logout',
    SendVerificationCodeForResetPassword:
      environment.mainapiUrl + '/identity/reset-password-verification',
    ValidateVerificationCodeForResetPassword:
      environment.mainapiUrl + '/identity/reset-password-validation',
    ResetPassword: environment.mainapiUrl + '/identity/reset-password',
  },
  CommonApis: {
    GetVehiclesForDropDownLists:
      environment.mainapiUrl + '/common/vehicles-lists',
    GoogleCustomToken: environment.messagingUrl + '/conversations/custom-token',
    regionsLocations:
      environment.mainapiUrl + '/regions-locations/get-location-name-by-ids',
  },
  ConfigurationsApi: {
    GetAllConfigurations: `${environment.mainapiUrl}/configuration/configurations`,
    GetGoogleAPIConfigurations: `${environment.mainapiUrl}/configuration/configuration/`,
  },
  Route: {
    getAllVehiclesList: `${environment.mainapiUrl}/route/get-all-vehicles-list`,
    routesByMultiLocations: `${environment.dispatchUrl}/route/routes-by-multi-locations`,
    Allroutesfordropdownlist: `${environment.dispatchUrl}/route/get-all-routes-for-drop-down-list`,
  },

  Tools: {
    GetAllTools: `${environment.mainapiUrl}/tools/get-all`,
    GetAllToolsForDraw: `${environment.mainapiUrl}/tools/gdraw`,
    GetToolsById: `${environment.mainapiUrl}/tools/get/`,
    PostTools: `${environment.mainapiUrl}/tools/add`,
    PutTools: `${environment.mainapiUrl}/tools/edit`,
    UpdateToolsStatus: `${environment.mainapiUrl}/tools/update-status/`,
    CheckToolExists: `${environment.mainapiUrl}/tools/check-exists/`,
  },

  TasksAssignments: {
    GetAllTasksAssignments: `${environment.dispatchUrl}/task-assignment/get-all`,
    CreateTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    GetTaskAssignmentById: `${environment.dispatchUrl}/task-assignment/get-by-id`,
    EditTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    DeleteTaskAssignment: `${environment.dispatchUrl}/task-assignment`,
    UpdateTaskAssignmentStatus: `${environment.dispatchUrl}/task-assignment/update-status`,
  },

  BI: {
    get_guest_token: `${environment.BIUrl}/guest-token`,
  },

  BIAction: {
    GetAllUsers: `${environment.BIUrl}/action/get-all-users`,
    ShareDashboard: `${environment.BIUrl}/action/share-dashboard`,
    SubmitInquiry: `${environment.BIUrl}/action/submit-inquiry`,
    get_dashboards: `${environment.BIUrl}/action/get-dashboards`,
    get_earning_code: `${environment.BIUrl}/action/get-earning-code`,
    get_pay_component_group: `${environment.BIUrl}/action/get-pay-component-group`,
    get_periods: `${environment.BIUrl}/action/get-periods`,
    get_all_lookup_by_id: `${environment.BIUrl}/action/get-all-lookup-by-id`,
  },

  BICard: {
    get_overtime_header: `${environment.BIUrl}/card/get-overtime-header`,
    get_deadhead_header: `${environment.BIUrl}/card/get-deadhead-header`,
    get_paid_routed_time_header: `${environment.BIUrl}/card/get-paid-routed-time-header`,
    get_paid_routed_time_drilldown_header: `${environment.BIUrl}/card/get-paid-routed-time-drilldown-header`,
    get_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/get-time-monitoring-drill-down-workday`,
    get_time_monitoring_drill_down_by_tecurve: `${environment.BIUrl}/card/get-time-monitoring-drill-down-workday-by-teCurve`,
    get_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/get-route-schedule-actual-paid-drill-down`,
    export_chart: `${environment.BIUrl}/card/export-chart`,
    share_chart: `${environment.BIUrl}/card/share-chart`,
    copy_chart: `${environment.BIUrl}/card/copy-chart`,
    get_deadhead_header_share: `${environment.BIUrl}/card/get-deadhead-header-share`,
    get_overtime_header_share: `${environment.BIUrl}/card/get-overtime-header-share`,
    get_paid_routed_time_header_share: `${environment.BIUrl}/card/get-paid-routed-time-header-share`,
    get_paid_routed_time_header_export: `${environment.BIUrl}/card/get-paid-routed-time-header-export`,
    get_paid_routed_time_header_copy: `${environment.BIUrl}/card/get-paid-routed-time-header-copy`,
    ge_overtime_header_export: `${environment.BIUrl}/card/get-overtime-header-export`,
    ge_overtime_header_copy: `${environment.BIUrl}/card/get-overtime-header-copy`,
    get_deadhead_header_export: `${environment.BIUrl}/card/get-deadhead-header-export`,
    get_deadhead_header_copy: `${environment.BIUrl}/card/get-deadhead-header-copy`,
    get_time_monitoring: `${environment.BIUrl}/card/get-time-monitoring`,
    get_time_monitoring_share: `${environment.BIUrl}/card/get-time-monitoring-share`,
    get_time_monitoring_export: `${environment.BIUrl}/card/get-time-monitoring-export`,
    get_time_monitoring_copy: `${environment.BIUrl}/card/get-time-monitoring-copy`,
    get_time_trending: `${environment.BIUrl}/card/get-time-trending`,
    get_time_trending_share: `${environment.BIUrl}/card/get-time-trending-share`,
    get_time_trending_export: `${environment.BIUrl}/card/get-time-trending-export`,
    get_time_trending_copy: `${environment.BIUrl}/card/get-time-trending-copy`,
    get_rout_schdule_actul_paid: `${environment.BIUrl}/card/get-rout-schdule-actul-paid`,
    get_rout_schdule_actul_paid_share: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-share`,
    get_rout_schdule_actul_paid_export: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-export`,
    get_rout_schdule_actul_paid_copy: `${environment.BIUrl}/card/get-rout-schdule-actul-paid-copy`,
    get_overtime_drilldown: `${environment.BIUrl}/card/get-overtime-drilldown`,
    get_routed_time_drilldown: `${environment.BIUrl}/card/get-routed-time-drilldown`,
    get_paid_routed_time_drilldown: `${environment.BIUrl}/card/get-paid-routed-time-drilldown`,
    export_overtime_drilldown: `${environment.BIUrl}/card/export-overtime-drilldown`,
    export_paid_routed_time_drilldown: `${environment.BIUrl}/card/export-paid-routed-time-drilldown`,
    export_routed_time_drilldown: `${environment.BIUrl}/card/export-routed-time-drilldown`,
    export_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/export-time-monitoring-drill-down-workday`,
    export_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/export-time-monitoring-drill-down-workday-by-teCurve`,
    export_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/export-route-schedule-actual-paid-drill-down`,
    copy_overtime_drilldown: `${environment.BIUrl}/card/copy-overtime-drilldown`,
    copy_paid_routed_time_drilldown: `${environment.BIUrl}/card/copy-paid-routed-time-drilldown`,
    copy_routed_time_drilldown: `${environment.BIUrl}/card/copy-routed-time-drilldown`,
    copy_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/copy-time-monitoring-drill-down-workday`,
    copy_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/copy-time-monitoring-drill-down-workday-by-teCurve`,
    copy_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/copy-route-schedule-actual-paid-drill-down`,
    share_overtime_drilldown: `${environment.BIUrl}/card/share-overtime-drilldown`,
    share_paid_routed_time_drilldown: `${environment.BIUrl}/card/share-paid-routed-time-drilldown`,
    share_routed_time_drilldown: `${environment.BIUrl}/card/share-routed-time-drilldown`,
    share_time_monitoring_drill_down_workday: `${environment.BIUrl}/card/share-time-monitoring-drill-down-workday`,
    share_time_monitoring_drill_down_workday_by_tecurve: `${environment.BIUrl}/card/share-time-monitoring-drill-down-workday-by-teCurve`,
    share_route_schedule_actual_paid_drill_down: `${environment.BIUrl}/card/share-route-schedule-actual-paid-drill-down`,
  },

  BIDashboards: {
    add_dashboard: `${environment.BIUrl}/dashboard/add-dashboard`,
    edit_dashboard: `${environment.BIUrl}/dashboard/edit-dashboard`,
    delete_dashboard: `${environment.BIUrl}/dashboard/delete-dashboard`,
    update_dashboard_status: `${environment.BIUrl}/dashboard/update-status`,
    get_all_dashboards: `${environment.BIUrl}/dashboard/get-all-dashboards`,
  },

  BIGroups: {
    add_group: `${environment.BIUrl}/group/add-group`,
    edit_group: `${environment.BIUrl}/group/edit-group`,
    delete_group: `${environment.BIUrl}/group/delete-group`,
    get_all_groups: `${environment.BIUrl}/group/get-all-groups`,
    get_group_by_id: `${environment.BIUrl}/group/get-group-by-id`,
    update_group_status: `${environment.BIUrl}/group/update-status`,
    get_groups_users: `${environment.BIUrl}/group/get-users-groups`,
    add_group_user: `${environment.BIUrl}/group/add-user-to-group`,
    update_user_group_status: `${environment.BIUrl}/group/update-status-user-group`,
    delete_user_group: `${environment.BIUrl}/group/delete-user-group`,
    edit_user_groups: `${environment.BIUrl}/group/edit-user-groups`,
    getDashboardsByAccountId: `${environment.BIUrl}/group/get-dashboards-by-accountId`,
  },

  BIScreens: {
    get_all_screens: `${environment.BIUrl}/screen/get-all-screens`,
    get_bi_portal_settings: `${environment.BIUrl}/group/get-bi-portal-settings`,
  },
};
